<router-outlet />

<app-notification-popup
*ngIf="showPopup"
[data]="notification"
[loading]="popupLoading"
[errorMessage]="popupError"
[selectedAction]="selectedAction"
(action)="handleAction($event)">
</app-notification-popup>

